import Line from "../components/Line";
import NavBar from "../components/NavBar";
import {PageWrapper} from "../components/PageWrapper";
import {Main} from "../components/Main";
import Footer from "../components/Footer";
import styled from "styled-components";
import {Mail, Phone, MapPin, Printer} from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import {MainBody} from "../components/MainBody";
import {AllCaps} from "../components/AllCaps";


export default function Contact() {
    return (
        <PageWrapper>
            <SiteHeader caption={"Kontakt"}/>
            <NavBar/>
            <MainBody>
                <Main>
                    <ContactContainer>
                        <h1>Kontakt</h1>
                        <AllCaps>
                        <p>Hier finden Sie alle wichtigen Kontaktinformationen.</p>
                        </AllCaps>
                        <ContactInfo>
                            <ContactItem as="a" href="mailto:info@dafa-dachtechnik.de">
                                <Mail size={24} />
                                <span>info@dafa-dachtechnik.de</span>
                            </ContactItem>

                            <ContactItem as="a" href="tel:+4922419052702">
                                <Phone size={24} />
                                <span>+49 (0) 2241-905 27 02</span>
                            </ContactItem>
                            <ContactItem>
                                <Printer size={24} />
                                <span>+49 (0) 2241-905 27 03</span>
                            </ContactItem>
                            <ContactItem>
                                <MapPin size={24}/>
                                <span>Vorgebigsblick 30, 53844 Troisdorf</span>
                            </ContactItem>
                        </ContactInfo>
                    </ContactContainer>
                </Main>
            </MainBody>
            <Line/>
            <Footer/>
        </PageWrapper>
    );
}

const ContactContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 40px;
    background: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 600px;
    margin: auto;

    h1 {
        font-size: 2rem;
        color: #333;
    }

    p {
        font-size: 1.2rem;
        color: #666;
    }
`;

const ContactInfo = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

const ContactItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.2rem;
    color: #333;
`;